import type { ComponentType } from 'react';
import { ProfilePage } from './ProfilePage';

/**
 * PROFIL EKRANININ KAYDI.
 *
 * AYNI BILESEN UC MENU KIMLIGINDE: her bolgenin kendi profil ogesi var
 * (`customer.profile`, `exchange.profile`, `admin.profile`) cunku rotalari
 * farkli (`/musteri/profil`, `/buro/profil`, `/yonetim/profil`). Ekranin
 * kendisi bolgeye gore degil OTURUMA gore degisiyor; uc ayri kopya, ucunun
 * zamanla ayrismasi demek olurdu.
 */
export const profileScreens = {
  'customer.profile': ProfilePage,
  'exchange.profile': ProfilePage,
  'admin.profile': ProfilePage,
} as const satisfies Readonly<Record<string, ComponentType>>;
